import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpensePolicyStateClass } from './interfaces/expensePolicyStateClass'
import { sortData } from "../../../common/timeLiveFunction";

const initialState: ExpensePolicyStateClass = {
    isLoading: false,
    status: 'idle',
    expensePolicyList: [],
    selectedRecord: {},
    isReload : false,
    MasterExpensePolicyId : '',
    sortOrder: 'asc',
    sortColumn: 'ExpensePolicyName',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        expensePolicy: ExpensePolicyStateClass;
    },
}
export const getAccountExpensePolicyAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'expensePolicy/getAccountExpensePolicy',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicies', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getAccountExpensePolicyByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicy/getAccountExpensePolicyById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicies/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    
    export const addAccountExpensePolicyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicy/addAccountExpensePolicy',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicies/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateAccountExpensePolicyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicy/UpdateAccountExpensePolicy',
        async (arg, thunkApi) => {
            const { AccountExpensePolicyId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/ExpensePolicies/' + AccountExpensePolicyId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAccountExpensePolicyAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicy/deleteAccountExpensePolicy',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicies/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const deleteAllSelectedRecordExpensePolicyAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordExpensePolicy",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/ExpensePolicies/DeleteAllSelectedRecordExpensePolicy/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        }
    )
    


  
export const expensePolicySlice = createSlice({
    name: 'expensePolicy',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },  
        checkedState: (state, action) => {
            const currentindex = state.expensePolicyList.findIndex((item) => item.AccountExpensePolicyId == action.payload);
            const newArray = [...state.expensePolicyList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.expensePolicyList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expensePolicyList.findIndex((item) => item.AccountExpensePolicyId == action.payload);
            const newArray = [...state.expensePolicyList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expensePolicyList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.expensePolicyList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expensePolicyList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.expensePolicyList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expensePolicyList = newArray;
            //state.isAllUnChecked = true;
        },

        updateMasterExpensePolicyId: (state, action: PayloadAction<any>) => {
            state.MasterExpensePolicyId = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.expensePolicyList;
            state.expensePolicyList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountExpensePolicyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountExpensePolicyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.expensePolicyList = [];
                } else {
                    state.expensePolicyList = payload.Data;
                    state.expensePolicyList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountExpensePolicyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

                
            })
           .addCase(getAccountExpensePolicyByIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountExpensePolicyByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getAccountExpensePolicyByIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addAccountExpensePolicyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountExpensePolicyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountExpensePolicyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
           
            .addCase(updateAccountExpensePolicyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountExpensePolicyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountExpensePolicyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAccountExpensePolicyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountExpensePolicyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAccountExpensePolicyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordExpensePolicyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAllSelectedRecordExpensePolicyAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordExpensePolicyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateMasterExpensePolicyId,updatePagination,updateSorting
} = expensePolicySlice.actions
 export const expensePolicyStateClass = (state: RootState) => state.expensePolicy
 export default expensePolicySlice.reducer